import { fetchFromOldApi } from '~/services/Http';

export const postAppearanceSettings = (postData: FormData) =>
  fetchFromOldApi(`/form/custom/appearance`, {
    method: 'PUT',
    body: postData,
  }).then((resp) => resp.json());
